import type { GoModalSettings } from './go-modal-bootstrap.factory';

interface LegacyModalA11yData {
	dialogTitleId?: string;
	dialogAriaLabel?: string;
}

export function applyLegacyModalA11y (
	options: GoModalSettings
): GoModalSettings {
	const modalData = options.modalData as LegacyModalA11yData | undefined;

	if (options.ariaLabelledBy == null && modalData?.dialogTitleId != null) {
		options.ariaLabelledBy = modalData.dialogTitleId;
	}

	if (options.ariaLabel == null && options.ariaLabelledBy == null && modalData?.dialogAriaLabel != null) {
		options.ariaLabel = modalData.dialogAriaLabel;
	}

	return options;
}

export function applyLegacyModalA11yAttributes (
	document: Document
): void {
	const modalWindows = document.querySelectorAll<HTMLElement>('.modal[tabindex="-1"]');

	modalWindows.forEach((modalWindow) => {
		modalWindow.setAttribute('role', 'dialog');
		modalWindow.setAttribute('aria-modal', 'true');
	});
}
